import React, { useRef, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import i18n from '../../../utils/ChrI18n';
import { formatToISODate } from '../Utils/commonUtils';

const MonthPicker = props => {
  const monthPickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (monthPickerRef.current && !monthPickerRef.current.contains(event.target))
        props.setShowMonthPicker(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if(document.querySelector(".cui-react-calendar")) {
      document.querySelector(".react-calendar__navigation__prev-button").setAttribute(
        "title",
        i18n.t("feature.full_calendar.content.previous_year")
      );
      document.querySelector(".react-calendar__navigation__next-button").setAttribute(
        "title",
        i18n.t("feature.full_calendar.content.next_year")
      );
    }
  })

  const handleMonthClick = date => {
    props.setShowMonthPicker(false);
    props.calendarRef.current.getApi().gotoDate(formatToISODate(date));
  };

  useEffect(() => {
    monthPickerRef.current.querySelector('.react-calendar__tile--active').focus();
  }, [])

  return(
    <div className="cui-react-calendar" ref={ monthPickerRef }>
      <Calendar
        maxDetail="year"
        locale={ i18n.locale }
        onClickMonth={ (date, _event) => handleMonthClick(date) }
        defaultValue={ props.calendarRef.current.getApi().getDate() }
        formatMonth={ (_locale, date) => fullCalendarTranslations.monthNamesShort[date.getMonth()] }
      />
    </div>
  )
};

export default React.memo(MonthPicker);